import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

Vue.use(Router);

// eslint-disable-next-line no-unused-vars
function isAuthenticated() {
  return store.getters.isAuthenticated;
}

const router = new Router({
  routes: [
    // eslint-disable-next-line spaced-comment
    /*{
      path: '/',
      component: () => import('@/views/Home'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/HomeGlobal'),
          beforeEnter: ifNotAuthenticated,
        },
      ],
    },*/
    {
      path: '/',
      component: () => import('@/layouts/FullLayout'),
      children: [
        {
          path: '',
          redirect: { name: 'accesos' },
        },
        {
          path: 'pre_registro',
          name: 'pre_registro',
          component: () => import('@/views/pre_registro'),
        },
        {
          path: 'accesos',
          name: 'accesos',
          component: () => import('@/views/accesos'),
        },
        {
          path: 'captura_accesos',
          name: 'captura_accesos',
          component: () => import('@/views/captura_accesos'),
        },
        {
          path: '/usuarios',
          name: 'usuarios',
          component: () => import('@/views/users'),
        },
        {
          path: '/captura_residentes',
          name: 'captura_residentes',
          component: () => import('@/views/captura_residentes'),
        },
        {
          path: '/captura_viviendas',
          name: 'captura_viviendas',
          component: () => import('@/views/captura_viviendas'),
        },
        {
          path: '/historico',
          name: 'historico',
          component: () => import('@/views/historico'),
        },
        {
          path: '/historico_obras',
          name: 'historico_obras',
          component: () => import('@/views/historico_obras'),
        },
        {
          path: 'historico_pre_registro',
          name: 'historico_pre_registro',
          component: () => import('@/views/historico_pre_registro'),
        },
        {
          path: '/captura_colaboradores',
          name: 'colaboradores',
          component: () => import('@/views/captura_colaboradores'),
        },
        {
          path: '/accesos_colaboradores',
          name: 'accesos_colaboradores',
          component: () => import('@/views/accesos_colaboradores'),
        },
        {
          path: '/captura_colaboradores/:id',
          name: 'captura_colaboradores',
          component: () => import('@/views/captura_colaboradores'),
        },
        {
          path: '/agregar_colaborador',
          name: 'agregar_colaborador',
          component: () => import('@/views/captura_colaboradores'),
        },
        {
          path: '/detalles_colaborador/:id',
          name: 'detalles_colaborador',
          component: () => import('@/views/detalles_colaborador'),
        },
        {
          path: '/listado_colaboradores',
          name: 'listado_colaboradores',
          component: () => import('@/views/listado_colaboradores'),
        },
        {
          path: '/historico_acceso_colaboradores',
          name: 'historico_acceso_colaboradores',
          component: () => import('@/views/historico_accesos_colaboradores'),
        },
        {
          path: '/asistencias',
          name: 'asistencias',
          component: () => import('@/views/rh'),
        },
        {
          path: 'asistencias/vacaciones/:id',
          name: 'vacaciones',
          component: () => import('@/views/vacaciones'),
        },
        {
          path: 'asistencias/turnos_dobles/:id',
          name: 'turnos_dobles',
          component: () => import('@/views/turnos_dobles'),
        },
        {
          path: 'asistencias/incapacidades/:id',
          name: 'incapacidades',
          component: () => import('@/views/incapacidades'),
        },
        {
          path: 'asistencias/inasistencias/:id',
          name: 'inasistencias',
          component: () => import('@/views/inasistencias'),
        },
        {
          path: 'asistencias/descansos/:id',
          name: 'descansos',
          component: () => import('@/views/descansos'),
        },
        {
          path: '/porticos',
          name: 'porticos',
          component: () => import('@/views/porticos'),
        },
        {
          path: 'porticos/detalles_portico/:id',
          name: 'detalles_portico',
          component: () => import('@/views/detalles_portico'),
        },
        {
          path: 'asistencias/desempenio/:id',
          name: 'desempenios',
          component: () => import('@/views/desempenios'),
        },
        {
          path: 'asistencias/formacion/:id',
          name: 'formaciones',
          component: () => import('@/views/formaciones'),
        },
        {
          path: 'asistencias/incidencia/:id',
          name: 'incidencias',
          component: () => import('@/views/incidencias'),
        },
        {
          path: '/avisos',
          name: 'avisos',
          component: () => import('@/views/avisos'),
        },
        {
          path: 'avisos/detalles_aviso/:id',
          name: 'detalles_aviso',
          component: () => import('@/views/avisos_detalle'),
        },
        {
          path: '/objetos_perdidos',
          name: 'reglamentos',
          component: () => import('@/views/reglamentos'),
        },
        {
          path: '/listado_domesticos',
          name: 'listado_domesticos',
          component: () => import('@/views/listado_domesticos'),
        },
        {
          path: '/agregar_domestico',
          name: 'agregar_domestico',
          component: () => import('@/views/captura_domesticos'),
        },
        {
          path: '/detalles_domestico/:id',
          name: 'detalles_domestico',
          component: () => import('@/views/detalles_domestico'),
        },
        {
          path: '/captura_domestico/:id',
          name: 'captura_domestico',
          component: () => import('@/views/captura_domesticos'),
        },
        {
          path: '/busqueda_telefono_residente',
          name: 'busqueda_telefono_residente',
          component: () => import('@/views/busqueda_telefono_residente'),
        },
        {
          path: '/listado_mascotas',
          name: 'listado_mascotas',
          component: () => import('@/views/listado_mascotas'),
        },
        {
          path: '/agregar_mascota',
          name: 'agregar_mascota',
          component: () => import('@/views/captura_mascotas'),
        },
        {
          path: '/detalles_mascota/:id',
          name: 'detalles_mascota',
          component: () => import('@/views/detalles_mascota'),
        },
        {
          path: '/captura_mascota/:id',
          name: 'captura_mascota',
          component: () => import('@/views/captura_mascotas'),
        },
        {
          path: '/listado_licencias',
          name: 'listado_licencias',
          component: () => import('@/views/listado_licencias'),
        },
        {
          path: '/detalles_licencia/:id',
          name: 'detalles_licencia',
          component: () => import('@/views/detalles_licencia'),
        },
        {
          path: '/editar_licencia/:id',
          name: 'editar_licencia',
          component: () => import('@/views/captura_licencias'),
        },
        {
          path: '/agregar_licencia',
          name: 'agregar_licencia',
          component: () => import('@/views/captura_licencias'),
        },
        {
          path: '/listado_vehiculos',
          name: 'listado_vehiculos',
          component: () => import('@/views/listado_vehiculos'),
        },
        {
          path: '/detalles_vehiculo/:id',
          name: 'detalles_vehiculo',
          component: () => import('@/views/detalles_vehiculo'),
        },
        {
          path: '/editar_vehiculo/:id',
          name: 'editar_vehiculo',
          component: () => import('@/views/captura_vehiculos'),
        },
        {
          path: '/agregar_vehiculo',
          name: 'agregar_vehiculo',
          component: () => import('@/views/captura_vehiculos'),
        },
      ],
    },
    {
      path: '/login',
      component: () => import('@/layouts/SimpleLayout'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('@/views/auth'),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !isAuthenticated()) next({ name: 'login' });
  else next();
});

export default router;
